<template>
  <img
    v-if="flagIcon"
    :width="size"
    :height="size"
    :src="flagIcon"
    :alt="`Флаг ${countryName}`"
    role="presentation"
  />
  <span
    v-else
    class="bg-white-400 rounded-full"
    :class="`h-[${size}px] w-[${size}px]`"
  />
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { getFlagIconByCountryId } from '../lib';

  const props = withDefaults(
    defineProps<{
      countryId: number;
      size?: number;
      countryName?: string;
    }>(),
    {
      size: 32,
      countryName: '',
    },
  );

  const flagIcon = computed(() => getFlagIconByCountryId(props.countryId));
</script>
